import dayjs from "dayjs";

import {
  addMessage,
  addMessages,
  resetChat,
} from "@/context/redux/reducers/chat-slice";
import { Oriented } from "@/data/constants/oriented";
import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useAppDispatch } from "@/hooks/redux-hooks";
import { useLang } from "@/hooks/use-lang";
import { xssFilter } from "@/utils/xss";

import { useWgptQuota } from "../../historical-dialog-sidebar/services/get-wgpt-quota";
import { getReachLimitSession } from "../data/reach-limit-session";
import { useChatStream } from "../services/chat-stream";

export const useChat = () => {
  const { t } = useLang();
  const { profile } = useAuth();
  const dispatch = useAppDispatch();
  const { mutate: sendQuestion, isLoading } = useChatStream();
  const { data: quotaData } = useWgptQuota();
  const isReachedLimit =
    !quotaData?.available || !!quotaData?.blocked || quotaData?.remains <= 0;

  const handleReachLimitSession = () => {
    dispatch(resetChat());
    const limitSession = getReachLimitSession({
      t,
      plan: profile?.plan ?? "Free",
      isReachedLimit: true,
    });

    if (limitSession) {
      dispatch(addMessages(limitSession({ quota: quotaData?.available ?? 0 })));
    }
  };

  const handleSubmit = ({
    query,
    investStyle,
    sessionId,
    isDefaultQuestion,
  }: {
    query: string;
    investStyle: Oriented | null;
    sessionId?: string;
    isDefaultQuestion?: boolean;
  }) => {
    if (isReachedLimit && !isDefaultQuestion) {
      handleReachLimitSession();
      return;
    }

    if (!sessionId) {
      dispatch(resetChat());
    }

    const filterQuery = xssFilter(query);
    if (!filterQuery) return;

    dispatch(
      addMessage({
        messageId: `client-${query}-${dayjs().format("YYYY-MM-DD HH:mm:ss")}`,
        type: "client",
        content: filterQuery,
      })
    );
    sendQuestion({
      query: filterQuery,
      investStyle,
      sessionId,
    });
  };

  return {
    handleReachLimitSession,
    handleSubmit,
    isLoading,
  };
};
